<template>
    <div class="tsa-pullToRefresh" @scroll="scrollFun">
        <van-pull-refresh v-model="refreshLoading" @refresh="onRefresh">
            <van-list
                v-model="moreLoading"
                :finished="finished"
                :immediate-check="false"
                finished-text="没有更多了"
                @load="onLoad"
            >
                <slot></slot>
            </van-list>
        </van-pull-refresh>
    </div>
</template>

<script>
import { debounce } from '@/common/utils'
export default {
    data () {
        return {
            refreshLoading: false,
            moreLoading: false,
            finished: false,
        }
    },
    methods: {
        onRefresh () {
            this.$emit('on-refresh')
        },
        setRefreshLoading (val) {
            this.refreshLoading = val
        },
        setMoreLoading (val) {
            this.moreLoading = val
        },
        setFinished (val) {
            this.finished = val
        },
        onLoad () {
            this.$emit('on-load')
            setTimeout(() => {
                // this.moreLoading = false
            }, 2000);
        },
        scrollFun: debounce(function(e) {
            this.$emit('on-scroll')
        }, 200),
    }
}
</script>

<style lang="less" scoped>
    .tsa-pullToRefresh {
        width: 100%;
        height: 100%;
        overflow: auto;
    }
</style>